import Icon from '../components/Icon.vue'

Icon.register({
  marker: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M94 290A327-327 0 0 1 0.2 485.1L0.1 485.3C-1.6 500.6 11.3 513.5 26.6 511.9A327-327 0 0 1 222 418.1L297.4 342.6 169.3 214.6 94 290zM485.5 26.5C450.1-8.8 392.8-8.8 357.5 26.5L335.7 48.3 299.2 11.7C283.5-3.9 258.2-3.9 242.6 11.7L138.5 115.8C132.2 122.1 132.2 132.2 138.5 138.5L161.1 161.1C167.3 167.3 177.5 167.3 183.7 161.1L270.9 73.9 290.5 93.5 192 192 320 320 485.5 154.5C520.8 119.2 520.8 61.9 485.5 26.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/marker.js
// module id = 4xiN
// module chunks = 144